export var ListSymbolType;
(function (ListSymbolType) {
    ListSymbolType["BULLETPOINTS"] = "Bulletpoints";
    ListSymbolType["CHECKMARKS"] = "Haken";
    ListSymbolType["NUMBERS"] = "Nummerierung";
})(ListSymbolType || (ListSymbolType = {}));
export var ListOrderType;
(function (ListOrderType) {
    ListOrderType["UL"] = "ul";
    ListOrderType["OL"] = "ol";
})(ListOrderType || (ListOrderType = {}));
//# sourceMappingURL=MsList.js.map